import Resource from './Resource';

export default class GetPreCandidatesFromCityResource extends Resource {
  constructor(token, id) {
    super(token);
    this.id = id;
  }

  async result() {
    try {
      const { data, status } = await this.request.get(`/pre-candidatos/${this.id}`);

      if (status === 200) {
        return data.pre_candidatos; //eslint-disable-line
      }
    } catch (error) {
      console.log(error); //eslint-disable-line
    }
    return {};
  }
}
